import script from "./DetailsProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsProduct.vue?vue&type=script&setup=true&lang=js"

import "./DetailsProduct.vue?vue&type=style&index=0&id=99ae0920&lang=css"

const __exports__ = script;

export default __exports__